import { render, staticRenderFns } from "./PayHead.vue?vue&type=template&id=41d0bede&scoped=true&"
import script from "./PayHead.vue?vue&type=script&lang=js&"
export * from "./PayHead.vue?vue&type=script&lang=js&"
import style0 from "./PayHead.vue?vue&type=style&index=0&id=41d0bede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d0bede",
  null
  
)

export default component.exports